/** Date-period filters used by the Members and Work Log pages (same presets as the original app). */
import { addDays, fmtDate, today } from './format';

export type PeriodKey = 'last7' | 'today' | 'week' | 'month' | 'all' | 'custom';
export const PERIODS: [PeriodKey, string][] = [
  ['last7', 'Last 7 days'],
  ['today', 'Today'],
  ['week', 'This week'],
  ['month', 'This month'],
  ['all', 'All time'],
  ['custom', 'Custom range'],
];
export type DateRange = [string, string];

export const periodRange = (key: PeriodKey, from = '', to = ''): DateRange => {
  const t = today();
  switch (key) {
    case 'today':
      return [t, t];
    case 'week': {
      const d = new Date(t + 'T00:00:00');
      return [addDays(t, -((d.getDay() + 6) % 7)), t];
    }
    case 'month':
      return [t.slice(0, 8) + '01', t];
    case 'last7':
      return [addDays(t, -6), t];
    case 'custom':
      return [from || '', to || ''];
    default:
      return ['', ''];
  }
};

export const inRange = (date: string, [a, b]: DateRange): boolean => (!a || date >= a) && (!b || date <= b);

export const periodLabel = (key: PeriodKey, r: DateRange): string =>
  key === 'all' ? 'all time' : key === 'custom' ? `${fmtDate(r[0])} – ${fmtDate(r[1])}` : PERIODS.find((x) => x[0] === key)![1].toLowerCase();
